<template>
  <v-container
    v-if="isShare"
    fluid
    class="saudi-briefcase saudi-briefcase-share"
  >
    <v-row class="mb-4 saudi-briefcase-share-header-row">
      <v-col
        class="py-0 pl-0 mt-8 d-flex align-items-center saudi-briefcase-share-title-col"
      >
        <span class="pt-3 saudi-briefcase-share-back">
          <v-icon
            style="cursor: pointer; width: 12px"
            @click="closeHandler()"
            size="36"
            >mdi-arrow-left</v-icon
          >
        </span>
        <span
          class="h3 pt-4 pl-3 shared-data-people saudi-briefcase-share-title"
        >
          Select people you want to share with
        </span>
      </v-col>
      <v-col class="py-0 pr-0 mt-12 saudi-briefcase-share-search-col">
        <v-text-field
          class="searchField saudi-briefcase-search"
          v-model="attendeeSearchField"
          solo
          hide-details
          prepend-inner-icon="search"
          label="Search User"
          clearable
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-list
        class="share-people saudi-briefcase-share-list"
        style="width: 100%"
      >
        <!-- <v-checkbox
          @click="selectAllClicked()"
          label="Select All"
          v-model="selectAll"
          class="mt-0"
        > -->
        <!-- <template #label> -->
        <p
          class="pt-1 pb-4 saudi-briefcase-share-hint"
          style="font-size: 1.125rem; font-weight: 400; color: #848484"
        >
          Select up to 5 attendees to share at a time
        </p>
        <!-- </template>
        </v-checkbox> -->
        <v-list-item v-for="(item, index) in attendeeList" :key="index">
          <v-checkbox
            class="checkBoxBriefcase mt-0 py-3"
            v-model="selected"
            multiple
            :value="item"
          >
            <template #label>
              <v-avatar size="80px" v-if="item.ProfilePictureURL">
                <v-img :src="item.ProfilePictureURL" />
              </v-avatar>
              <v-avatar size="80px" color="grey" v-else
                ><span
                  style="display: inline-block; font-size: 2rem; color: #fff"
                  >{{ getInitials(item.title) }}</span
                ></v-avatar
              >
              <span class="pt-1 pl-3">{{ item.title }}</span>
            </template>
          </v-checkbox>
        </v-list-item>
      </v-list>
    </v-row>
    <div class="saudi-briefcase-share-action">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="shareData()"
            normal
            color="success"
            class="saudi-briefcase-share-btn"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon size="20" class="mr-2" color="#fff">share</v-icon>
            <span>Share</span>
          </v-btn>
        </template>
        <span>Share</span>
      </v-tooltip>
    </div>
  </v-container>
  <v-container v-else fluid class="saudi-briefcase">
    <v-row class="saudi-briefcase-title-row">Virtual Briefcase</v-row>
    <v-row dense class="saudi-briefcase-meta-row" style="margin: 0 -15px">
      <v-col class="mob_full_width saudi-briefcase-count-col">
        <span class="saudi-briefcase-count"
          >{{ briefCaseObjects.length }} items</span
        ></v-col
      >
      <v-col class="mob_full_width saudi-briefcase-tools-col">
        <v-row class="saudi-briefcase-tools-row">
          <v-col cols="8" class="py-0 pr-0">
            <v-text-field
              class="searchField saudi-briefcase-search"
              v-model="searchField"
              solo
              hide-details
              prepend-inner-icon="search"
              label="Search Items"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="py-0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  height="48"
                  color="#cbcbcb"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="filter-butn btn saudi-briefcase-filter-btn"
                >
                  <v-icon color="black">filter_list</v-icon>
                  <span class="pl-2" style="color: black"> Filter</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="filterSelected(item)"
                  style="cursor: pointer"
                  v-for="(item, index) in entityTypes"
                  :key="index"
                >
                  <v-list-item-title>{{ item.ENTITY_NAME }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="saudi-briefcase-tabs-row">
      <v-tabs
        slider-color="#000"
        v-model="tabSelection"
        class="saudi-briefcase-tabs"
      >
        <v-tab
          active-class="tab-active"
          data-analytics
          data-page-name="/briefcase"
          data-action="click"
          data-action-type="tab"
          data-action-label="ViewedMyBriefcaseTab"
          @click="getBriefcaseVals()"
          ><span style="font-size: 16px"> My Briefcase</span></v-tab
        >
        <v-tab
          active-class="tab-active"
          data-page-name="/briefcase"
          data-action="click"
          data-action-type="tab"
          data-action-label="ViewedSharedBookmarkTab"
          @click="getSharedWithMe()"
          ><span style="font-size: 16px"> Shared With Me</span></v-tab
        >
      </v-tabs>
    </v-row>
    <v-row class="pt-8 mt-8" align="center" justify="center" v-if="loader">
      <v-progress-circular
        size="80"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>

    <v-row
      align="center"
      justify="center"
      style="height: 70%"
      class="px-8"
      v-else-if="!loader && briefCaseObjects.length == 0"
    >
      <span
        class="h3"
        style="
          text-align: center;
          font-weight: 400;
          font-size: 1.25rem;
          color: #cbcbcb;
        "
        v-if="tabSelection == 0 && !searchField"
      >
        <v-icon dark size="60" color="#cbcbcb" class="d-block"
          >mdi-bookmark-plus-outline</v-icon
        >
        Look for the Bookmark icon in attendees, speakers, exhibitors, resources
        and more to add to your Briefcase. Once added, you can view and access
        all your bookmarks here</span
      >
      <span
        class="h3"
        style="
          text-align: center;
          font-weight: 400;
          font-size: 1.25rem;
          color: #cbcbcb;
        "
        v-else-if="tabSelection == 0 && searchField"
      >
        <v-icon dark size="60" color="#cbcbcb" class="d-block"
          >mdi-bookmark-plus-outline</v-icon
        >
        No Bookmarks Found</span
      >
      <span
        class="h3"
        style="
          font-weight: 400;
          font-size: 1.25rem;
          color: #cbcbcb;
          text-align: center;
        "
        v-else
      >
        <v-icon dark size="60" color="#cbcbcb" class="d-block"
          >mdi-bookmark-plus-outline</v-icon
        >
        You have no shared bookmarks
      </span>
    </v-row>
    <v-row
      v-else
      class="py-2 single-briefcase-list saudi-briefcase-item"
      @click="routeToPath(object)"
      v-for="(object, i) in briefCaseObjects"
      :key="i"
    >
      <v-col cols="1" class="py-0 pl-0 saudi-briefcase-item-avatar-col">
        <v-avatar
          size="80"
          v-if="object.entityImage"
          class="saudi-briefcase-item-avatar"
        >
          <v-img
            :src="object.entityImage"
            class="exhibit-image"
            @error="object.entityImage = ''"
          ></v-img>
        </v-avatar>
        <span class="name-initial-wrap saudi-briefcase-item-initial" v-else>{{
          getInitials(object.entityName)
        }}</span>
      </v-col>
      <v-col cols="9" class="py-0 pr-0 saudi-briefcase-item-name-col">
        <span class="h5 m-0 shared-file-name saudi-briefcase-item-name">
          {{ object.entityName }}
        </span>
      </v-col>
      <v-col class="py-0 saudi-briefcase-item-actions-col" cols="2">
        <div class="pr-3 saudi-briefcase-item-share-wrap">
          <v-btn
            class="btn saudi-briefcase-item-share-btn"
            v-if="!object.isShared"
            color="primary"
            @click.stop="initiateShare(object)"
            icon
            aria-label="Share"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9.51 4.23 18.07 8.51c3.84 1.92 3.84 5.06 0 6.98l-8.56 4.28c-5.76 2.88-8.11.53-5.23-5.23l.87-1.73c.22-.44.22-1.17 0-1.61L4.28 9.46C1.4 3.7 3.76 1.35 9.51 4.23Z"
                stroke="#26282b"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.41 12H14.84"
                stroke="#26282b"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-btn>
          <div v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-avatar v-on="on" v-bind="attrs" v-if="object.senderPhotoUrl">
                  <v-img
                    :src="object.senderPhotoUrl"
                    @error="object.senderPhotoUrl = ''"
                  />
                </v-avatar>
                <v-avatar v-on="on" v-bind="attrs" color="grey" v-else>{{
                  getInitials(object.senderName)
                }}</v-avatar>
              </template>
              <span>Shared by {{ object.senderName }}</span>
            </v-tooltip>
          </div>
        </div>
        <span class="saudi-briefcase-item-delete-wrap">
          <v-btn
            class="btn saudi-briefcase-item-delete-btn"
            v-if="!object.isShared"
            @click.stop="deleteBriefcase(object)"
            icon
            aria-label="Delete"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M21 5.98c-3.33-.33-6.68-.5-10.02-.5-1.98 0-3.96.1-5.94.3L3 5.98M8.5 4.97l.22-1.31c.16-.95.28-1.66 1.97-1.66h2.62c1.69 0 1.82.75 1.97 1.67l.22 1.3M18.85 9.14l-.65 10.07c-.11 1.57-.2 2.79-2.99 2.79H8.79c-2.79 0-2.88-1.22-2.99-2.79L5.15 9.14M10.33 16.5h3.33M9.5 12.5h5"
                stroke="#26282b"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-btn>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";
import db from "@/components/firebaseInit";
var sharedWithMe;

var self;
export default {
  data() {
    return {
      tabSelection: null,
      attendeeSearchField: "",
      isShare: false,
      currentBookmark: {},
      selectAll: false,
      loader: false,
      selected: [],
      entityTypes: [],
      briefCaseObjects: [],
      briefCaseObjectsOriginal: [],
      APIs: APIs,
      searchField: "",
      attendeeList: [],
      originalAttendeeList: [],
    };
  },
  watch: {
    selected() {
      if (this.selected.length > 5) {
        this.selected.pop();
      }
    },
    attendeeSearchField(searchText) {
      if (searchText) {
        this.attendeeList = [];
        this.$nextTick(() => {
          this.attendeeList = this.originalAttendeeList.filter((val) =>
            val.title.toLowerCase().includes(searchText.toLowerCase())
          );
        });
      } else {
        this.attendeeList = [];
        this.attendeeList = this.originalAttendeeList;
      }
      this.checked = [];
    },
    searchField(searchText) {
      if (searchText)
        this.briefCaseObjects = [
          ...this.briefCaseObjectsOriginal.filter((val) =>
            val.entityName.toLowerCase().includes(searchText.toLowerCase())
          ),
        ];
      else this.briefCaseObjects = [...this.briefCaseObjectsOriginal];
    },
  },
  mounted() {
    self = this;
    this.fetchAllAttendees();
    this.getBriefcaseVals();
    this.entityTypes = [
      { ENTITY_TYPE: "0", ENTITY_NAME: "All" },
      // { ENTITY_TYPE: "1", ENTITY_NAME: "Session" },
      { ENTITY_TYPE: "2", ENTITY_NAME: "Speaker" },
      { ENTITY_TYPE: "3", ENTITY_NAME: "Attendee" },
      { ENTITY_TYPE: "4", ENTITY_NAME: "Expo" },
      { ENTITY_TYPE: "5", ENTITY_NAME: "Sponsor" },
      { ENTITY_TYPE: "6", ENTITY_NAME: "Resource" },
      // { ENTITY_TYPE: "7", ENTITY_NAME: "Meeting" }
    ];
    self.AddEventAnalytics({
      pageName: "/briefcase",
      action: "click",
      actiontype: "tab",
      actionLabel: "ViewedMyBriefcaseTab",
    });
  },
  methods: {
    getSharedWithMe() {
      this.loader = true;
      let that = this;
      let clientId = this.$store.state.client[0].id;
      let eventId = this.$store.state.eventid;
      let attendeeId = this.$store.state.userId;
      let path = `/OA_UAT_${clientId}${eventId}/AttendeeList/Attendees/${attendeeId}/shared-with-me/`;
      if (sharedWithMe) {
        sharedWithMe();
      }
      try {
        sharedWithMe = db.collection(path).onSnapshot((querySnapshot) => {
          this.briefCaseObjects = [];
          this.briefCaseObjectsOriginal = [];
          console.log(querySnapshot.size);
          if (querySnapshot.size > 0) {
            querySnapshot.forEach((element) => {
              let data = element.data();
              data.sharedItems[0].isShared = true;
              data.sharedItems[0].senderName = data.senderName;
              data.sharedItems[0].senderPhotoUrl = data.senderPhotoUrl;
              this.briefCaseObjects.push(data.sharedItems[0]);
              this.briefCaseObjectsOriginal.push(data.sharedItems[0]);
              console.log(data);
            });
          }
          that.loader = false;
        });
      } catch (e) {
        that.loader = false;
        console.log(e);
      }
    },
    routeToPath(bookmark) {
      this.$emit("closeOnClick");
      if (bookmark.entityType == 6) {
        if (bookmark.entityMetadata.HyperLinkUrl) {
          window.open(bookmark.entityMetadata.HyperLinkUrl);
        } else if (
          bookmark.entityMetadata.ResourceType == "pdf" &&
          bookmark.entityMetadata.ResourcePath
        ) {
          window.open(bookmark.entityMetadata.ResourcePath);
        } else {
          window.open(bookmark.entityMetadata.ResourcePath);
        }
      } else if (bookmark.entityLink) {
        if (bookmark.entityType == this.entityTypes[4].ENTITY_TYPE) {
          this.$store.commit("addSponsorID", bookmark.entityId);
          this.$router.replace({
            path: bookmark.entityLink,
            params: { sid: bookmark.entityId },
            query: {
              sid: bookmark.entityId,
            },
          });
        } else
          this.$router.replace({
            path: bookmark.entityLink,
            params: { sid: bookmark.entityId },
            query: {
              sid: bookmark.entityId,
            },
          });
      } else {
        return;
      }
    },
    initiateShare(object) {
      this.isShare = true;
      this.currentBookmark = object;
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          var x = document.getElementsByClassName("v-card__text")[0];
          x.scrollTo(0, 0);
        }, 0);
      });
    },
    closeHandler() {
      this.selected = [];
      this.selectAll = false;
      this.isShare = false;
    },
    shareData() {
      let sharedData = {};
      sharedData.atteendees = this.selected;
      sharedData.selectedBookmark = this.currentBookmark;
      let attendeeIds = [];
      this.selected.forEach((attendee) => {
        attendeeIds.push(attendee.id);
      });
      this.selected = [];
      this.selectAll = false;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          sharedWithUserIds: attendeeIds,
          sharedItems: [this.currentBookmark],
          senderName: this.$store.state.user[0].name,
          senderPhotoUrl: this.$store.state.user[0].profilepic
            ? this.$store.state.user[0].profilepic
            : "",
        },
      };
      axios({
        method: "post",
        url: this.APIs.BookmarkAPIConfig.Share,
        data: rqstData,
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + this.getSessionToken(),
        },
      })
        .then(() => {
          this.showSnackbar("Briefcase data shared");
        })
        .catch((err) => {
          console.log(err);
        });
      this.isShare = false;
    },
    selectAllClicked() {
      if (this.selectAll) {
        let selectedCheck = [];
        for (var i = 0; i < 5; i++) {
          selectedCheck.push(this.attendeeList[i]);
        }
        this.selected = selectedCheck;
      } else {
        this.selected = [];
      }
    },
    getInitials(name) {
      return common.getInitials(name);
    },
    fetchAllAttendees() {
      var obj = this.$store.state;
      var loggedInUserId = obj.user[0].id;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
      };
      let keys = {
        instanceId: "OA_UAT",
        clientId: obj.client[0].id,
        eventId: obj.eventid,
      };
      this.attendeeList = [];
      let rqstData = {
        key: keys,
        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "WEB",
        },
      };
      axios
        .post(this.APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          responseData.data.result.map((attendee) => {
            if (loggedInUserId != attendee.AttendeeId) {
              this.attendeeList.push({
                title: attendee.Name,
                id: attendee.AttendeeId,
                ProfilePictureURL: attendee.ProfilePictureURL,
                checked: false,
              });
              this.originalAttendeeList.push({
                title: attendee.Name,
                id: attendee.AttendeeId,
                ProfilePictureURL: attendee.ProfilePictureURL,
                checked: false,
              });
            }
          });
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    deleteBriefcase(object) {
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityId: object.entityId,
        },
      };
      this.briefCaseObjects = this.briefCaseObjects.filter(
        (val) => val.entityId != object.entityId
      );
      this.briefCaseObjectsOriginalthis = this.briefCaseObjectsOriginal.filter(
        (val) => val.entityId != object.entityId
      );
      axios({
        method: "post",
        url: this.APIs.BookmarkAPIConfig.Delete,
        data: rqstData,
      })
        .then(() => {})
        .catch(() => {});
    },
    filterSelected(selectedFilter) {
      if (selectedFilter.ENTITY_TYPE != 0) {
        this.briefCaseObjects = [
          ...this.briefCaseObjectsOriginal.filter((val) => {
            return val.entityType == selectedFilter.ENTITY_TYPE;
          }),
        ];
      } else this.briefCaseObjects = [...this.briefCaseObjectsOriginal];
    },
    getBriefcaseVals() {
      this.loader = true;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
        },
      };
      this.briefCaseObjects = [];
      this.briefCaseObjectsOriginal = [];
      axios({
        method: "post",
        url: this.APIs.BookmarkAPIConfig.Get,
        data: rqstData,
      })
        .then((res) => {
          this.loader = false;
          let briefcases = res.data;
          briefcases.forEach((bookmark) => {
            if (bookmark.isPublished) {
              bookmark.shareMenu = false;
              this.briefCaseObjects.push(bookmark);
              this.briefCaseObjectsOriginal.push(bookmark);
            }
          });
        })
        .catch((e) => {
          this.loader = false;
          console.log(e);
        });
    },
  },
};
</script>

<style>
.checkBoxBriefcase > .label {
  margin-bottom: 0px;
}
/* .client-dialog-briefcase .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #cbcbcb;
} */
.tab-active {
  color: #000 !important;
}
.searchField .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #cbcbcb;
}
.client-dialog-briefcase button.filter-butn {
  background: #fff !important;
  box-shadow: none !important;
  border: 1px solid #cbcbcb !important;
}
.exhibit-image .v-image__image--cover {
  background-size: 100%;
}
.single-briefcase-list .v-avatar {
  border: 1px solid #838383;
}
.v-card__text {
  overflow-x: hidden;
}
span.name-initial-wrap {
  height: 80px;
  width: 80px;
  display: inline-flex;
  background: #a3a3a3;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 36px;
  color: #fff;
}
.checkBoxBriefcase .v-messages {
  display: none;
}
.share-people .v-list-item {
  width: 100%;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  margin-bottom: 15px;
  background: #f3f3f3;
}
.checkBoxBriefcase .v-label {
  margin: 0;
}
.checkBoxBriefcase .v-input__slot {
  margin: 0;
}
.single-briefcase-list:first-child {
  padding-top: 15px !important;
}
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .shared-data-people {
    font-size: 18px !important;
  }
  .shared-file-name {
    padding-left: 35px;
  }
}

/* =========================================================================
   Saudi-themed Virtual Briefcase redesign — Figma node 36713:4587.
   Scoped overlay: no functionality / data / dynamic logic changes. All
   v-if / v-for / v-model / @click / methods preserved verbatim. Only
   visual layout, colors, borders, tab pills, and icon glyphs change.
   ========================================================================= */
.client-dialog-briefcase.saudi-briefcase-dialog {
  border-radius: 20px !important;
  box-shadow: 0 24px 60px rgba(28, 29, 38, 0.18) !important;
  overflow: visible !important;
}
.client-dialog-briefcase.saudi-briefcase-dialog > .v-card.saudi-briefcase-card {
  background: #ffffff !important;
  border-radius: 20px !important;
  box-shadow: none !important;
  width: 100% !important;
  max-width: 894px;
  position: relative;
  overflow: hidden;
}
/* Close button must overlay the top-right corner so it aligns with the
   "Virtual Briefcase" title row instead of taking its own row above it.
   The card is the absolute parent. */
.client-dialog-briefcase.saudi-briefcase-dialog .saudi-briefcase-card {
  position: relative;
}
.client-dialog-briefcase.saudi-briefcase-dialog .saudi-briefcase-close {
  position: absolute !important;
  top: 3px !important;
  right: 10px !important;
  width: 50px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  z-index: 3;
  padding: 10px;
  margin: 0 !important;
}
/* Reserve room on the title row so a long title can't slide under the
   absolute-positioned close button. */
.saudi-briefcase .saudi-briefcase-title-row {
  padding-right: 60px !important;
}
.client-dialog-briefcase.saudi-briefcase-dialog .saudi-briefcase-body {
  padding: 30px !important;
  background: #ffffff;
}
.client-dialog-briefcase.saudi-briefcase-dialog
  .saudi-briefcase-body
  > .container.saudi-briefcase {
  padding: 0 !important;
}

/* Title "Virtual Briefcase" */
.saudi-briefcase .saudi-briefcase-title-row {
  font-family: "Inter", sans-serif !important;
  font-size: 30px !important;
  font-weight: 600 !important;
  line-height: 30px !important;
  color: #000000 !important;
  text-transform: none !important;
  margin: 0 !important;
  padding: 0 0 20px !important;
}

/* Item count + search/filter row — single horizontal row, count left,
   search+filter right. Forces no-wrap so Vuetify doesn't stack them. */
.saudi-briefcase .saudi-briefcase-meta-row.row {
  margin: 0 !important;
  padding: 0 0 20px !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
}
.saudi-briefcase .saudi-briefcase-count-col.col,
.saudi-briefcase .col.saudi-briefcase-count-col {
  padding: 0 !important;
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none !important;
}
.saudi-briefcase .saudi-briefcase-count {
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  color: #000000 !important;
  white-space: nowrap;
}
.saudi-briefcase .saudi-briefcase-tools-col.col,
.saudi-briefcase .col.saudi-briefcase-tools-col {
  padding: 0 !important;
  flex: 0 0 auto !important;
  width: 410px !important;
  max-width: 410px !important;
}
.saudi-briefcase .saudi-briefcase-tools-row.row {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  gap: 10px;
  justify-content: flex-end !important;
  align-items: center !important;
  width: 100% !important;
}
.saudi-briefcase .saudi-briefcase-tools-row > .col,
.saudi-briefcase .saudi-briefcase-tools-row > [class*="col-"] {
  padding: 0 !important;
  margin: 0 !important;
  flex: 0 0 auto !important;
  max-width: none !important;
}
.saudi-briefcase .saudi-briefcase-tools-row > .col:first-child,
.saudi-briefcase .saudi-briefcase-tools-row > [class*="col-"]:first-child {
  width: 300px !important;
  flex: 0 0 300px !important;
}
.saudi-briefcase .saudi-briefcase-tools-row > .col:last-child,
.saudi-briefcase .saudi-briefcase-tools-row > [class*="col-"]:last-child {
  width: 100px !important;
  flex: 0 0 100px !important;
}

/* Ensure the search v-text-field actually paints — Vuetify's solo
   mode strips most borders, so we explicitly draw the Figma border
   chrome on the inner slot. */
.saudi-briefcase .saudi-briefcase-search.v-text-field {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Search field — match Figma filter-input (white bg, #c2c9d0 border, rounded 6) */
.saudi-briefcase
  .saudi-briefcase-search.v-text-field.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background: #ffffff !important;
  border: 1px solid #c2c9d0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  min-height: 44px !important;
  padding: 0 14px !important;
}
.saudi-briefcase .saudi-briefcase-search .v-label,
.saudi-briefcase .saudi-briefcase-search input::placeholder {
  font-family: "Inter", sans-serif !important;
  font-size: 15px !important;
  color: #26282b !important;
  opacity: 0.6 !important;
}
.saudi-briefcase .saudi-briefcase-search input {
  color: #26282b !important;
  font-size: 15px !important;
}
.saudi-briefcase .saudi-briefcase-search .v-input__prepend-inner .v-icon {
  font-size: 18px !important;
  color: #26282b !important;
  opacity: 0.9;
  margin-right: 6px;
}

/* Filter button — match Figma filter-input */
.saudi-briefcase .saudi-briefcase-filter-btn.v-btn {
  background: #ffffff !important;
  border: 1px solid #c2c9d0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  height: 44px !important;
  min-width: 0 !important;
  padding: 0 14px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 15px !important;
}
.saudi-briefcase .saudi-briefcase-filter-btn .v-btn__content {
  color: #26282b !important;
}
.saudi-briefcase .saudi-briefcase-filter-btn .v-icon {
  color: #26282b !important;
  font-size: 18px !important;
}

/* Tabs as pills — active dark, inactive plain */
.saudi-briefcase .saudi-briefcase-tabs-row {
  margin: 0 !important;
  padding: 0 0 14px !important;
}
.saudi-briefcase .saudi-briefcase-tabs.v-tabs,
.saudi-briefcase .saudi-briefcase-tabs .v-tabs-bar {
  background: transparent !important;
  height: auto !important;
}
.saudi-briefcase .saudi-briefcase-tabs .v-tab {
  background: transparent !important;
  color: #000000 !important;
  border-radius: 100px !important;
  text-transform: none !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  padding: 8px 18px 8px 14px !important;
  margin-right: 10px !important;
  height: 40px !important;
  min-width: 0 !important;
  opacity: 1 !important;
}
.saudi-briefcase .saudi-briefcase-tabs .v-tab--active,
.saudi-briefcase .saudi-briefcase-tabs .v-tab.tab-active {
  background: #26282b !important;
  color: #ffffff !important;
}
.saudi-briefcase .saudi-briefcase-tabs .v-tabs-slider,
.saudi-briefcase .saudi-briefcase-tabs .v-tabs-slider-wrapper {
  display: none !important;
}

/* Briefcase item row — bordered rounded card, 14px padding, single
   horizontal flex row (no wrap) */
.saudi-briefcase .saudi-briefcase-item.row {
  border: 1px solid #e9eef3 !important;
  border-radius: 10px !important;
  padding: 14px !important;
  margin: 0 0 10px !important;
  cursor: pointer;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  background: #ffffff;
  width: 100%;
  gap: 10px;
}
.saudi-briefcase .saudi-briefcase-item.row:hover {
  background: #fafbfc;
}

/* Avatar — 70px circle, teal-to-green gradient when no image */
.saudi-briefcase .saudi-briefcase-item-avatar-col.col,
.saudi-briefcase .saudi-briefcase-item-avatar-col {
  flex: 0 0 70px !important;
  max-width: 70px !important;
  width: 70px !important;
  padding: 0 14px 0 0 !important;
  margin: 0 !important;
}
.saudi-briefcase .saudi-briefcase-item-avatar.v-avatar,
.saudi-briefcase .saudi-briefcase-item-initial {
  width: 70px !important;
  height: 70px !important;
  min-width: 70px !important;
  border-radius: 50% !important;
  font-family: "Inter", sans-serif !important;
  font-size: 21px !important;
  font-weight: 400 !important;
  color: #26282b !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  background: radial-gradient(
    circle at 30% 35%,
    #bfe4ff 0%,
    #b6f3a1 100%
  ) !important;
  border: 0 !important;
  overflow: hidden;
  text-transform: uppercase;
}

/* Name / Title block — flex-grow to fill middle, no wrapping */
.saudi-briefcase .saudi-briefcase-item-name-col.col,
.saudi-briefcase .saudi-briefcase-item-name-col {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: none !important;
  width: auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 0 14px 0 0 !important;
}
.saudi-briefcase .saudi-briefcase-item-name {
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  padding-left: 0 !important;
  word-break: break-word;
  white-space: normal;
}

/* Action icons — send + trash, 24px outline, far-right group */
.saudi-briefcase .saudi-briefcase-item-actions-col.col,
.saudi-briefcase .saudi-briefcase-item-actions-col {
  flex: 0 0 auto !important;
  max-width: none !important;
  width: auto !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 20px;
}
.saudi-briefcase .saudi-briefcase-item-share-wrap {
  padding: 0 !important;
}
.saudi-briefcase .saudi-briefcase-item-share-wrap,
.saudi-briefcase .saudi-briefcase-item-delete-wrap {
  padding: 0 !important;
}
.saudi-briefcase .saudi-briefcase-item-share-btn.v-btn,
.saudi-briefcase .saudi-briefcase-item-delete-btn.v-btn {
  background: transparent !important;
  box-shadow: none !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  border-radius: 6px !important;
  color: #26282b !important;
}
.saudi-briefcase .saudi-briefcase-item-share-btn.v-btn:hover,
.saudi-briefcase .saudi-briefcase-item-delete-btn.v-btn:hover {
  background: rgba(0, 0, 0, 0.04) !important;
}

/* Empty / loader rows */
.saudi-briefcase .row.pt-8.mt-8,
.saudi-briefcase .row.px-8 {
  margin: 0 !important;
  padding: 30px 0 !important;
}

/* ========================================================================
   Share view (isShare === true) — same design language as the main view.
   Reserve 60px on top so the share-view header (back arrow + title +
   search field) sits below the dialog's 50px close-circle button which
   is anchored to v-card top:10 right:10. */
.saudi-briefcase.saudi-briefcase-share {
  padding: 60px 0 0 !important;
  position: relative;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-header-row.row {
  margin: 20px 0 14px !important;
  padding: 0 !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-title-col.col {
  padding: 0 !important;
  margin: 0 !important;
  flex: 1 1 auto !important;
  max-width: none !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 !important;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: transparent;
  flex-shrink: 0;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-back .v-icon {
  color: #26282b !important;
  font-size: 28px !important;
  width: 28px !important;
  height: 28px !important;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-title {
  font-family: "Inter", sans-serif !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
  color: #000000 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-search-col.col {
  padding: 0 !important;
  margin: 0 !important;
  flex: 0 0 300px !important;
  max-width: 300px !important;
}

.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-hint {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  color: #6c7180 !important;
  margin: 0 0 14px !important;
}

/* Body row (wrapping the v-list) keeps Vuetify's default -12px margin,
   which pushes the hint and list cards left of the title row. Zero the
   margin and remove v-list's default padding so the hint, list cards,
   and title share the same left edge. */
.saudi-briefcase.saudi-briefcase-share
  > .row:not(.saudi-briefcase-share-header-row) {
  margin: 0 !important;
  padding: 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-list.share-people {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Share-list rows — rounded cards, no heavy shadow */
.saudi-briefcase.saudi-briefcase-share
  .saudi-briefcase-share-list.share-people
  .v-list-item {
  border: 1px solid #e9eef3 !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  margin: 0 0 10px !important;
  padding: 6px 14px !important;
  min-height: 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .checkBoxBriefcase {
  width: 100%;
  margin: 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .checkBoxBriefcase .v-input__slot {
  margin: 0 !important;
  padding: 8px 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .checkBoxBriefcase .v-label {
  display: flex !important;
  align-items: center !important;
  gap: 14px !important;
  margin: 0 !important;
  color: #1a3747 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}
.saudi-briefcase.saudi-briefcase-share
  .checkBoxBriefcase
  .v-input--selection-controls__input {
  margin-right: 8px !important;
}
.saudi-briefcase.saudi-briefcase-share .checkBoxBriefcase .v-icon {
  color: #c2c9d0 !important;
}
.saudi-briefcase.saudi-briefcase-share
  .checkBoxBriefcase.v-input--is-label-active
  .v-icon,
.saudi-briefcase.saudi-briefcase-share
  .checkBoxBriefcase.v-input--is-dirty
  .v-icon {
  color: #26282b !important;
}
.saudi-briefcase.saudi-briefcase-share .checkBoxBriefcase .v-avatar {
  width: 60px !important;
  height: 60px !important;
  min-width: 60px !important;
  background: radial-gradient(
    circle at 30% 35%,
    #bfe4ff 0%,
    #b6f3a1 100%
  ) !important;
  border: 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .checkBoxBriefcase .v-avatar span {
  color: #26282b !important;
  font-size: 18px !important;
  font-family: "Inter", sans-serif !important;
}

/* Share action button — dark filled pill at bottom right of the card */
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-action {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
  background: linear-gradient(to top, #ffffff 60%, rgba(255, 255, 255, 0));
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-btn.v-btn {
  background: #26282b !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 10px 18px !important;
  height: auto !important;
  min-height: 0 !important;
}
.saudi-briefcase.saudi-briefcase-share .saudi-briefcase-share-btn .v-icon {
  color: #ffffff !important;
}

/* Mobile */
@media only screen and (max-width: 767px) {
  .client-dialog-briefcase.saudi-briefcase-dialog .saudi-briefcase-body {
    padding: 20px !important;
  }
  .saudi-briefcase .saudi-briefcase-meta-row {
    flex-direction: column;
    align-items: stretch;
  }
  .saudi-briefcase .saudi-briefcase-tools-row {
    flex-wrap: wrap;
  }
  .saudi-briefcase .saudi-briefcase-item.row {
    padding: 12px !important;
  }
  .saudi-briefcase .saudi-briefcase-item-avatar.v-avatar,
  .saudi-briefcase .saudi-briefcase-item-initial {
    width: 56px !important;
    height: 56px !important;
    min-width: 56px !important;
    font-size: 18px !important;
  }
}
</style>
